import { nullable, number, object, string } from "superstruct";

const TikTokPostTagSchema = object({
    id: number(),
    postId: string(),
    variantId: number(),
    product: object({
        id: number(),
        title: string(),
        url: string(),
        thumbnail: string(),
        variant: object({
            id: number(),
            productId: number(),
            title: string(),
            price: string(),
            comparePrice: nullable(string()),
            imageUrl: nullable(string()),
        }),
    }),
});

export default TikTokPostTagSchema;
